import React from 'react'
import { Link } from 'react-router-dom'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import InterestCollectionModalSF from './InterestCollectionModalSF.js'
import BadgeUI from '../../../widgets/output/BadgeUI.js'
import CardUI from '../../../widgets/layout/CardUI.js'
import LinkWithSpinnerUI from '../../../widgets/action/LinkWithSpinnerUI'
import CustomerInvoicesNavUI from './CustomerInvoicesNavUI.js'

const CustomerInvoiceCollectionPageUI = ({ context, account, invoiceList, customerList, onRefreshClick,
  utilizeMode, onUtilizeClick, onUtilizeClickCancel, customerInvoiceList, selectedCustomerId, onShowInvoicesClick, showInvoices
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_rfc' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!account || !customerList}
    account={account} page='rf'
  >
    {
      (!account || !customerList) &&
      <SpinnerComponentUI />
    }
    {
      account && customerList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Receivable Financing</b></span>
            </div>
          }
          right={
            <div className='g_flex_h'>

            </div>
          }
        />
        <CustomerInvoicesNavUI context={context} account={account} page='collections' />

        {
          customerList && customerList.map((customer, i) =>
            <CardUI key={i} title={`Customer: ${customer.customerName}`}>
              <InvoiceTableUI context={context} customer={customer} invoiceList={invoiceList}
                utilizeMode={utilizeMode} onUtilizeClick={onUtilizeClick} onShowInvoicesClick={onShowInvoicesClick} showInvoices={showInvoices} />
            </CardUI>
          )
        }
      </div>
    }

    <InterestCollectionModalSF context={context} selectedCustomerId={selectedCustomerId} customerInvoiceList={customerInvoiceList}
      updateMode={utilizeMode} onCancelClick={onUtilizeClickCancel} onRefreshClick={onRefreshClick}
    />
  </SuperUserAccountPageUI>

const InvoiceTableUI = ({ context, customer, invoiceList, utilizeMode, onUtilizeClick, onShowInvoicesClick, showInvoices }) =>
  <div className='g_flex_v'>
    {/* <span>Total collected: {customer.collectedAmountF1}</span>
    <span>Total utilized: {customer.utilizedAmountF1}</span> */}
    <span>Total unutilized: {customer.unutilizedAmountF1}</span>
    {/* <LinkWithSpinnerUI
      label={`Utilize customer's unutilized funds to pay for invoices`}
      spinnerOnLeft={false}
      onClick={onUtilizeClick}
      rowId={customer.customerId}
      busy={utilizeMode}
    /> */}
    <Link to='#' onClick={onUtilizeClick} data-row-id={customer.customerId}>Utilize customer's unutilized funds to pay for invoices</Link>
    <LinkWithSpinnerUI
      label='Show disbursed and paid invoices'
      spinnerOnLeft={false}
      onClick={onShowInvoicesClick}
      rowId={customer.customerId}
      busy={showInvoices}
    />
    {
      invoiceList &&
      <table className='table g_m_top_100'>
        <thead>
          <tr>
            <th>Date</th>
            <th>Invoice name</th>
            <th>Invoice amount</th>
            <th>status</th>
          </tr>
        </thead>
        <tbody>
          {
            invoiceList.map((invoice, i) =>
              <tr key={i}>
                <td>{invoice.status === 'Disbursed' ? invoice.disbursedDateF1 : invoice.paidDateF1}</td>
                <td>{invoice.invoiceName}</td>
                <td>{invoice.invoiceAmountF2}</td>
                <td><BadgeUI label={invoice.status} /></td>
              </tr>
            )}
        </tbody>
      </table>
    }
    {/* {
      invoiceList && invoiceList.map((invoice, i) =>
        <div key={i} className='g_flex_h g_m_top_25'>
          <div className='g_flex_left'>
            <span>{invoice.status === 'Disbursed' ? invoice.disbursedDateF1 : invoice.paidDateF1}</span>
            <span className='g_m_left_50'>{invoice.invoiceName}</span>
            <span className='g_m_left_50'>{invoice.invoiceAmountF2}</span>
          </div>
          <span><BadgeUI label={invoice.status} /></span>
        </div>
      )
    } */}
  </div>

export default CustomerInvoiceCollectionPageUI
